<div style="height: 725px;">
  <h4 class="text-center">Nuevo registro</h4>
  <button class="btn-close" (click)="onNoClick()"></button>
  <mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChanged($event)">
    <mat-tab label="Requerimiento" class="mb-3">
      <ng-container [formGroup]="registerForm">
        <div class="mt-3">
          <app-user-detail formGroupName="userDetailReq"></app-user-detail>
          <app-requirement-detail formGroupName="requirementDetail" [contact]="contactReq"
            (validatingForm)="responseValidatingReq($event)"></app-requirement-detail>
        </div>
      </ng-container>
    </mat-tab>
    <mat-tab label="Reclamo">
      <ng-container [formGroup]="registerForm">
        <div class="reclaim-section mt-3">
          <app-user-detail formGroupName="userDetailRec"></app-user-detail>
          <app-reclaim-detail formGroupName="reclaimDetail" [contact]="contactRec"></app-reclaim-detail>
        </div>
      </ng-container>
    </mat-tab>
  </mat-tab-group>
  <div class="bottom-button">
    <button type="button" class="vs-btn-blue"
      [disabled]="selectedIndex === 0 ? registerForm.controls.requirementDetail.invalid || registerForm.controls.userDetailReq.invalid || invalidForm : registerForm.controls.reclaimDetail.invalid || registerForm.controls.userDetailRec.invalid"
      (click)="send()">
      Guardar
    </button>
  </div>
</div>